import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/footer.css";
import logo from "../assets/logo_bhadade.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid className="footer-container">
        <Row className="gy-4">
          {/* --- Logo & About --- */}
          <Col md={4} sm={12} className="footer-section">
            <img src={logo} alt="Logo" className="footer-logo" />
            <p className="footer-text">
              The ideal venue for dream events of any kind! This is a once
              in a lifetime event and you need to make it yours!
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=61583382143014&sk=sports" className="social-btn"><FontAwesomeIcon icon={faFacebook} /></a>
              <a href="https://www.instagram.com/bhadadecaterers?igsh=cjhjdnhxeHV1dHhx&utm_source=qr" className="social-btn"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="https://wa.me/919923314198" className="social-btn"><FontAwesomeIcon icon={faWhatsapp} /></a>
            </div>
          </Col>

          {/* --- Quick Links --- */}
          <Col md={4} sm={6} className="footer-section">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/events">Lawn/Hall</Link></li>
              <li><Link to="/golden">Golden Package</Link></li>
              <li><Link to="/silver1">Silver Package</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </Col>

          {/* --- Contact Info --- */}
          <Col md={4} sm={6} className="footer-section">
            <h5 className="footer-heading">Contact</h5>
            <p className="footer-text">Kharbi Chowk, Sakharkar Nagar, West Ring Road Nagpur</p>
            <a href="tel:+919923314198" className="footer-link">
              <FontAwesomeIcon icon={faPhone} /> 9923314198 / 8329775561
            </a>
            <br />
            <a href="mailto:bhadadegroup@gmail.com" className="footer-link">
              <FontAwesomeIcon icon={faEnvelope} /> bhadadegroup@gmail.com
            </a>
            <br />
            <a href="https://wa.me/919923314198" className="footer-link">
              <FontAwesomeIcon icon={faWhatsapp} /> Get details on WhatsApp
            </a>
          </Col>
        </Row>

        {/* --- Bottom Section --- */}
        <Row className="footer-bottom">
          <Col className="text-center">
            <p>© {new Date().getFullYear()} AmpleMind. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
